/**
 * @param {string} token
 * @return {Object}
 */
export const parseToken = (token) => {
  const tokenParts = token.split('.')
  return JSON.parse(atob(tokenParts[1]))
}
